import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  HERO_BANNER_GET: createSagaAction('HERO_BANNER_GET'),
}

// Actions
export const actions = {
  getHeroBanners: () => ({
    type: constants.HERO_BANNER_GET.ACTION,
  }),
}

// Action Handlers
const ACTION_HANDLERS = {
  [constants.HERO_BANNER_GET.ACTION]: (state) => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [constants.HERO_BANNER_GET.SUCCESS]: (state, action) => ({
    ...state,
    data: action.payload,
    isLoading: false,
    error: null,
  }),
  [constants.HERO_BANNER_GET.FAILED]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.message,
  }),
}

// Initial State
export const initialState = {
  data: null,
  isLoading: false,
  error: null,
}

// Reducer
export default createReducer(initialState, (state, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
})
